import { AppThunk } from "../../store/AppThunkType";
import { loadPermitRegisterUsersSuccessful, loadPermitRegisterUsersStarted } from "./actions";
import Database from "../../Database";

export function loadPermitRegisterUsers(permitRegisterId: string, permitTypeId: string): AppThunk {
    return function (dispatch) {
        dispatch(loadPermitRegisterUsersStarted());

        Database.queryPermitRegisterUsers(permitRegisterId, permitTypeId).then((result) => {
            dispatch(loadPermitRegisterUsersSuccessful(result));
        });
    };
}
